export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-04.9ed78dee.jpg";